import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { ESortType } from './api/core/resources/matchlist.resource';
import { INITIAL_INDEX } from './helpers/pagination';
import { IRootState } from './state';

export const initialRootState: IRootState = {
  account: { id: '' },
  asynchronousState: {
    [EAsyncEventTypes.BOOTSTRAP_APP]: { isLoading: true },
  },
  auth: {},
  blacklist: {
    list: [],
  },
  compatibilityReport: {
    entries: {},
  },
  configurations: {},
  counters: {
    favorite: 0,
    visit: 0,
    message: 0,
    photoRequest: 0,
  },
  favorites: {
    received: {
      list: [],
      meta: {
        currentPage: INITIAL_INDEX,
      },
    },
    sent: {
      list: [],
      meta: {
        currentPage: INITIAL_INDEX,
      },
    },
    nbFavorites: 0,
  },
  matches: {
    affiny: {
      list: [],
      originalList: [],
      additionalList: [],
    },
    sort: {
      sortType: ESortType.SCORE,
      list: [],
      meta: {
        currentPage: INITIAL_INDEX,
      },
    },
  },
  memberchoices: {},
  members: {
    entries: {},
  },
  messages: {
    entries: {},
  },
  navigation: {
    screen: undefined,
    params: undefined,
  },
  personalityReport: {},
  photoRequests: {
    entries: {},
    list: [],
    meta: {
      currentPage: 0,
    },
  },
  photoReveals: {
    entries: {},
    list: [],
    meta: {
      currentPage: 0,
    },
  },
  pictures: {
    entries: {},
  },
  products: {
    products: [],
  },
  paymentHistories: {
    entries: [],
  },
  reflists: {
    entriesMe: {},
    entriesOther: {},
    platform: '',
    kvk: '',
  },
  specialOffer: {},
  subscription: {
    pass: null,
    isSub: false,
    isCancellable: false,
    isAutoRenewal: false,
    isReactivable: false,
  },
  threads: {
    entries: {},
    list: [],
    meta: {
      currentPage: 0,
    },
  },
  visits: {
    received: {
      list: [],
      meta: {
        currentPage: INITIAL_INDEX,
        total: 0,
      },
    },
  },
  visibilityUi: {
    desktop: {
      mainLayout: true,
    },
  },
};
